import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.watchSignupLinks();
  }

  watchSignupLinks() {
    const footerComponent = this.element.querySelector("footer-component");
    const containers = [this.element, footerComponent.shadowRoot];
    containers.forEach((container) => {
      let host = container.getRootNode().host?.tagName;
      container.querySelectorAll("a[href*='/aanmelden']").forEach((link, index) => {
        link.addEventListener("click", this._handleSignupLinkClick(host, index));
      });
    });
  }

  _handleSignupLinkClick = (host, index) => (event) => {
    const linkText = event.target.textContent.trim();
    const linkUrl = event.target.href;
    let slice = event.target.closest("[data-slice]")?.dataset.slice;
    if (!slice && host) {
      slice = host.toLowerCase();
    }

    window.trackEvent({
      event: "signup_link_click",
      link_text: linkText,
      link_index: `${index}`,
      link_url: linkUrl,
      current_url: window.location.href,
      slice,
    });
  }
}
